export { default } from './RatingNumeric';
